import { render, staticRenderFns } from "./PaginaRicevute.vue?vue&type=template&id=702236bf"
import script from "./PaginaRicevute.vue?vue&type=script&lang=js"
export * from "./PaginaRicevute.vue?vue&type=script&lang=js"
import style0 from "./PaginaRicevute.vue?vue&type=style&index=0&id=702236bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports